module.exports = __webpack_public_path__ + "static/media/cart-icon.a7075b99.svg";